<template>
  <div class="row f-row justify-content-center">
    <div class="col col-11" style="height: 100%; overflow: auto;">
      <table class="table table-sm table-borderless real_time_table mt-2">
        <thead class="table-headers text-center align-center thead">
          <tr>
            <th style="width: 30px">#</th>
            <th>DATE</th>
            <th>
              NOTIONAL ({{
                currencySpecs[newSelectedAsset].currency_name.slice(0, 3)
              }})
            </th>
            <th v-for="(item, index) in strategyLegs" :key="index">
              {{ item }}
            </th>
          </tr>
        </thead>
      </table>
    </div>
    <div
      class="col col-11 tradeTableHeight"
      style="height: 100%; overflow: auto;"
    >
      <table class="table table-sm table-borderless real_time_table">
        <tbody>
          <tr v-for="(item, index) in newUserNewHedge" :key="index" class="tr">
            <td
              style="width: 30px"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ index + 1 }}
            </td>
            <td
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ item.date | dateFormat }}
            </td>
            <td
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ item.newHedge | formatM }}
            </td>
            <td
              style="text-align: right;"
              v-for="(itm, idx) in keys"
              :key="idx"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <span
                v-if="
                  selectedLegQuote.includes(idx) && quoteObjective === 'strike'
                "
                style="padding-right: 49%"
              >
                <i class="fa fa-question"></i>
              </span>
              <span v-else>
                <input
                  v-model.number.lazy="item[itm]"
                  placeholder="spot"
                  class="optim-input"
                  @change="onUserStrikeChange"
                />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col col-11" style="height: 100%; overflow: auto;">
      <table class="table table-sm table-borderless real_time_table">
        <thead>
          <tr>
            <th style="width: 30px"></th>
            <th></th>
            <th style="font-size: 1rem; text-align: center;">
              {{ allSubTotal | formatM }}
            </th>
            <th
              style="font-size: 1rem; text-align: right;"
              v-for="(ave, idx) in newAverages"
              :key="idx"
            >
              <span
                v-if="
                  (selectedLegQuote.includes(idx) &&
                    quoteObjective === 'strike') ||
                    isFwdOrFuture
                "
                style="padding-right: 49%"
              >
                <i class="fa fa-question"></i>
              </span>
              <span v-else>
                <input
                  class="optim-input"
                  :value="ave"
                  @input="val => onUserSingleAveChange(val, idx)"
                />
              </span>
            </th>
          </tr>
        </thead>
      </table>
    </div>
  </div>
</template>

<script>
import { format, timeParse, timeFormat } from "d3";

export default {
  name: "DateNotionalQuote",
  components: {},
  props: {
    averages: { required: true, default: () => [] },
    currencySpecs: { required: true, default: () => [] },
    isFwdOrFuture: { required: true, type: Boolean, default: false },
    quoteObjective: { required: false, default: "strike" },
    selectedAsset: { required: true, default: () => [] },
    selectedLegQuote: { required: false, default: -1 },
    strategies: { required: true, default: () => [] },
    strategyLegs: { required: true, default: () => [] },
    userNewHedge: { required: true, default: () => [] }
  },
  data() {
    return {
      highlightRow: -1,
      keys: [],
      newAverages: [],
      newSelectedAsset: 0,
      newUserNewHedge: []
    };
  },
  created() {
    try {
      this.countrySpecs = this.$store.state.countries.all.items;
    } catch (error) {
      console.log(`Error countries ${error}`);
    }
  },
  mounted() {
    this.newUserNewHedge = this.userNewHedge;
    if (this.newUserNewHedge.length > 0) {
      this.getKeys();
    }
    this.newSelectedAsset = this.selectedAsset;
    this.newAverages = this.averages.slice(1);
  },
  watch: {
    userNewHedge() {
      this.newUserNewHedge = this.userNewHedge;
      if (this.newUserNewHedge.length > 0) {
        this.getKeys();
      }
    },
    averages(val) {
      this.newAverages = val.slice(1);
    },
    selectedAsset() {
      this.newSelectedAsset = this.selectedAsset;
    }
  },
  computed: {
    allSubTotal() {
      return this.newUserNewHedge
        .map(item => +item.newHedge)
        .reduce((a, b) => a + b, 0);
    }
  },
  filters: {
    formatM: function(val) {
      return val === null || val === 0 ? "-" : format(",")(val);
    },
    formatCurr: function(val) {
      return val === null || val === 0 ? "-" : format(",.5r")(val);
    },
    formatPercent: function(value) {
      if (value) {
        return format(".1%")(value);
      }
    },
    dateFormat: function(val) {
      return val === null || val === "" || val === 0
        ? "-"
        : timeFormat("%d %b %y")(timeParse("%Y-%m-%d")(val));
    }
  },
  methods: {
    onHoverRow(idx) {
      this.highlightRow = idx;
    },
    getKeys() {
      let ks = Object.keys(this.newUserNewHedge[0]);
      this.keys = ks.filter(
        d => d !== "date" && d !== "newHedge" && d !== "fwd"
      );
    },
    onUserStrikeChange() {
      console.log("strike change");
    },
    onUserSingleAveChange(val, idx) {
      console.log(val);
      this.newAverages[idx] = val;
      console.log("single ave change");
    }
  }
};
</script>

<style scoped></style>
